import Vue from 'vue'

const initialState = {
  detail: {},
  taskDetail: {},
  loading: false,
  projects: [],
  branches: [],
  docTypes: [],
  registerBooks: [],
  document: {},
  upload: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  getters: {
    getProjectById: state => id => {
      return state.projects.find(project => project.id === parseInt(id))
    }
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    ADD_FILE(state, file) {
      state.detail = {
        ...state.detail,
        attachments: [...state.detail.attachments, file]
      }
    },
    REMOVE_FILE(state, fileId) {
      state.detail = {
        ...state.detail,
        attachments: state.detail.attachments.filter((file) => file.id !== fileId)
      }
    },
    ADD_COMMENT(state, comment) {
      state.detail = {
        ...state.detail,
        comments: [comment, ...state.detail.comments]
      }
    },
    EDIT_COMMENT(state, editedComment) {
      state.detail = {
        ...state.detail,
        comments: state.detail.comments.map(comment => {
          if (comment.id === editedComment.id) {
            return editedComment
          } else return comment
        })
      }
    },
    REMOVE_COMMENT(state, id) {
      state.detail = {
        ...state.detail,
        comments: state.detail.comments.filter((comment) => comment.id !== id)
      }
    },
  },
  actions: {
    getDetail({commit, state}, documentId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`workflow/documents/${documentId}/`).then(response => {
          commit('SET', {key: 'detail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    uploadFile({commit, state}, {file, type}) {
      let data = new FormData()
      data.append('file', file)
      if (type)
        data.append('type', type)
      commit('SET', {key: 'upload', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`workflow/documents/${state.detail.id}/attachments/`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          commit('ADD_FILE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'upload', val: false})
        })
      })
    },
    removeFile({commit, state}, fileId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`workflow/documents/${state.detail.id}/attachments/${fileId}/`).then(() => {
          commit('REMOVE_FILE', fileId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    nextState({commit, state}, note) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`workflow/documents/${state.detail.id}/next_state/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    nextStateById({commit, state}, {note, id}) {
      const documentId = id || state.detail.id
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`workflow/documents/${documentId}/next_state/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    reject({commit, state}, note) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`workflow/documents/${state.detail.id}/reject/`, {note}).then(response => {
          commit('ADD_DOCUMENT_STATE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations({commit, state}, documentId = null) {
      let path = `workflow/documents/relations/`
      if (documentId) {
        path = `workflow/documents/relations/?document_id=${documentId}`
      }
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.get(path).then(response => {
          commit('SET', {key: 'projects', val: response.data.projects})
          commit('SET', {key: 'branches', val: response.data.branches})
          commit('SET', {key: 'document', val: response.data.document})
          commit('SET', {key: 'docTypes', val: response.data.doc_types})
          commit('SET', {key: 'registerBooks', val: response.data.register_books})
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, document) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post('workflow/documents/', document).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, document) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.put(`workflow/documents/${document.id}/`, document).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createTask({commit, state}, task) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`workflow/documents/${state.detail.id}/tasks/`, task).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    cancel({commit, state}, note) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`workflow/documents/${state.detail.id}/cancel/`, {note}).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    createComment({commit, state}, text) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`workflow/documents/${state.detail.id}/comments/`, {text}).then(response => {
          commit('ADD_COMMENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    updateComment({commit, state}, {text, id}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.patch(`workflow/documents/${state.detail.id}/comments/${id}/`, {text}).then(response => {
          commit('EDIT_COMMENT', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    removeComment({commit, state}, id) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.delete(`workflow/documents/${state.detail.id}/comments/${id}/`).then(() => {
          commit('REMOVE_COMMENT', id)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
